import { render, staticRenderFns } from "./searchProgram.vue?vue&type=template&id=24ef97b6&scoped=true"
import script from "./searchProgram.vue?vue&type=script&lang=js"
export * from "./searchProgram.vue?vue&type=script&lang=js"
import style0 from "./searchProgram.vue?vue&type=style&index=0&id=24ef97b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef97b6",
  null
  
)

export default component.exports